import { Product, Client } from '@buffer-mono/tracking-plan'

import type {
  CommonTrackingProperties,
  AccountData as Account,
} from '~publish/contexts/AccountContext'

import type {
  AdditionalProperties,
  CoreMetadataProperties,
} from './trackingTypes'

export const getCoreTrackingMetadata = (
  account: Account | null,
): CoreMetadataProperties => {
  const organizationId = account?.currentOrganization?.id ?? null
  return {
    organizationId,
    product: Product.Publish,
    clientName: Client.PublishWeb,
  }
}

export const createEventTrackingData = <T extends AdditionalProperties>(
  metadata: Omit<CoreMetadataProperties, 'organizationId'> & {
    organizationId: string
  },
  commonProps: Partial<CommonTrackingProperties> | null,
  additionalProps: T,
): Omit<CoreMetadataProperties, 'organizationId'> & {
  organizationId: string
} & Partial<CommonTrackingProperties> &
  T => ({
  ...metadata,
  ...commonProps,
  ...additionalProps,
})
